import Header from "@/components/feature/Header";
import Hero from "@/components/feature/Hero";
import CategoryGrid from "@/components/feature/CategoryGrid";
import BlogSection from "@/components/feature/BlogSection";
import TrustSection from "@/components/feature/TrustSection";
import CTASection from "@/components/feature/CTASection";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://pandabuy.rest";

const homeSchemas: Record<string, unknown>[] = [
  {
    "@type": "Organization",
    name: "Pandabuy Spreadsheet Hub",
    url: siteUrl,
  },
  {
    "@type": "WebSite",
    name: "Pandabuy Spreadsheet Hub",
    url: siteUrl,
    description: "The ultimate pandabuyspreadsheet hub for 2026. Discover curated spreadsheet finds, trending fashion items, and high-quality shopping lists updated daily.",
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@type": "WebPage",
    name: "Pandabuy Spreadsheet Hub 2026 - Curated Fashion Finds &amp; Shopping Lists",
    url: siteUrl,
    description: "The ultimate pandabuyspreadsheet hub for 2026. Discover curated spreadsheet finds, trending fashion items, and high-quality shopping lists updated daily. Browse 14 categories across shoes, hoodies, t-shirts, jackets, accessories and more.",
    isPartOf: {
      "@type": "WebSite",
      name: "Pandabuy Spreadsheet Hub",
      url: siteUrl,
    },
  },
];

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={homeSchemas} />
      <Header />
      <section aria-label="Hero banner">
        <Hero />
      </section>
      <section aria-label="Product categories">
        <CategoryGrid />
      </section>
      <section aria-label="Blog content">
        <BlogSection />
      </section>
      <section aria-label="Trust and statistics">
        <TrustSection />
      </section>
      <section aria-label="Call to action">
        <CTASection />
      </section>
      <Footer />
    </main>
  );
}